<template>
    <div class="form">
        <a-card size="small" :title="c_title">
            <v-gobackbutton slot="extra">返回</v-gobackbutton>
        </a-card>

        <div>
            <a-card size="small" title="">

                <a-form-model :model="record" ref="ruleForm" :rules="rules" :layout="formItemLayout">
                    <a-row>
                        <a-form-item label="平台编码" ref="platformtype" prop="platformtype">
                            <a-input v-if="is_new" v-model="record.platformtype" @blur=" () => {$refs.platformtype.onFieldBlur();}" />
                            <span v-else>{{record.platformtype}}</span>
                        </a-form-item>
                        <a-form-item ref="platformtypename" label="平台名称" prop="platformtypename">
                            <a-input v-if="is_vue_task" v-model="record.platformtypename" @blur=" () => {$refs.platformtypename.onFieldBlur();}" />
                            <span v-else>{{record.platformtypename}}</span>
                        </a-form-item>
                    </a-row>

                    <a-row>
                        <p class="form_title">消息中心</p>
                        <a-form-item label="是否开启">
                            <a-radio-group v-if="is_vue_task" v-model="record.mcmsflag">
                                <a-radio value="1">开启</a-radio>
                                <a-radio value="0">关闭</a-radio>
                            </a-radio-group>
                            <span v-else>
                                <span v-if="record.mcmsflag == 1">开启</span>
                                <span v-else>关闭</span>
                            </span>
                        </a-form-item>
                        <a-form-item v-if="record.mcmsflag == '1'" label="是否自定义平台编码">
                            <a-radio-group v-if="is_vue_task" v-model="record.mcmscustom">
                                <a-radio value="1">是</a-radio>
                                <a-radio value="0">否</a-radio>
                            </a-radio-group>
                            <span v-else>
                                <span v-if="record.mcmscustom == 1">是</span>
                                <span v-else>否</span>
                            </span>
                        </a-form-item>
                        <a-form-item v-if="record.mcmscustom == 1 && record.mcmsflag == '1'" label="平台编码">
                            <a-input v-if="is_vue_task" v-model="record.mcmscode" />
                            <span v-else>{{record.mcmscode}}</span>
                        </a-form-item>
                    </a-row>
                    <a-row>
                        <p class="form_title">账号中心</p>
                        <a-form-item label="是否开启">
                            <a-radio-group v-if="is_vue_task" v-model="record.umsflag">
                                <a-radio value="1">开启</a-radio>
                                <a-radio value="0">关闭</a-radio>
                            </a-radio-group>
                            <span v-else>
                                <span v-if="record.umsflag == 1">开启</span>
                                <span v-else>关闭</span>
                            </span>
                        </a-form-item>
                        <a-form-item v-if="record.umsflag == '1'" label="是否自定义平台编码">
                            <a-radio-group v-if="is_vue_task" v-model="record.umscustom">
                                <a-radio value="1">是</a-radio>
                                <a-radio value="0">否</a-radio>
                            </a-radio-group>
                            <span v-else>
                                <span v-if="record.umscustom == 1">是</span>
                                <span v-else>否</span>
                            </span>
                        </a-form-item>
                        <a-form-item v-if="record.umscustom == 1 && record.umsflag == '1'" label="平台编码">
                            <a-input v-if="is_vue_task" v-model="record.umscode" />
                            <span v-else>{{record.umscode}}</span>
                        </a-form-item>
                    </a-row>
                    <a-row>
                        <p class="form_title">导入导出</p>
                        <a-form-item label="是否开启">
                            <a-radio-group v-if="is_vue_task" v-model="record.fmsflag">
                                <a-radio value="1">开启</a-radio>
                                <a-radio value="0">关闭</a-radio>
                            </a-radio-group>
                            <span v-else>
                                <span v-if="record.fmsflag == 1">开启</span>
                                <span v-else>关闭</span>
                            </span>
                        </a-form-item>
                        <a-form-item v-if="record.fmsflag == '1'" label="是否自定义平台编码">
                            <a-radio-group v-if="is_vue_task" v-model="record.fmscustom">
                                <a-radio value="1">是</a-radio>
                                <a-radio value="0">否</a-radio>
                            </a-radio-group>
                            <span v-else>
                                <span v-if="record.fmscustom == 1">是</span>
                                <span v-else>否</span>
                            </span>
                        </a-form-item>
                        <a-form-item v-if="record.fmscustom == 1 && record.fmsflag == '1'" label="平台编码">
                            <a-input v-if="is_vue_task" v-model="record.fmscode" />
                            <span v-else>{{record.fmscode}}</span>
                        </a-form-item>
                    </a-row>
                    <a-row>
                        <p class="form_title">云端配置</p>
                        <a-form-item label="是否开启">
                            <a-radio-group v-if="is_vue_task" v-model="record.configflag">
                                <a-radio value="1">开启</a-radio>
                                <a-radio value="0">关闭</a-radio>
                            </a-radio-group>
                            <span v-else>
                                <span v-if="record.configflag == 1">开启</span>
                                <span v-else>关闭</span>
                            </span>
                        </a-form-item>
                        <a-form-item v-if="record.configflag == '1'" label="是否自定义平台编码">
                            <a-radio-group v-if="is_vue_task" v-model="record.configcustom">
                                <a-radio value="1">是</a-radio>
                                <a-radio value="0">否</a-radio>
                            </a-radio-group>
                            <span v-else>
                                <span v-if="record.configcustom == 1">是</span>
                                <span v-else>否</span>
                            </span>
                        </a-form-item>
                        <a-form-item v-if="record.configcustom == 1 && record.configflag == '1'" label="平台编码">
                            <a-input v-if="is_vue_task" v-model="record.configcode" />
                            <span v-else>{{record.configcode}}</span>
                        </a-form-item>
                    </a-row>
                    <a-row>
                        <p class="form_title">OSS管理</p>
                        <a-form-item label="是否开启">
                            <a-radio-group v-if="is_vue_task" v-model="record.ossflag">
                                <a-radio value="1">开启</a-radio>
                                <a-radio value="0">关闭</a-radio>
                            </a-radio-group>
                            <span v-else>
                                <span v-if="record.ossflag == 1">开启</span>
                                <span v-else>关闭</span>
                            </span>
                        </a-form-item>
                        <a-form-item v-if="record.ossflag == '1'" label="是否自定义平台编码">
                            <a-radio-group v-if="is_vue_task" v-model="record.osscustom">
                                <a-radio value="1">是</a-radio>
                                <a-radio value="0">否</a-radio>
                            </a-radio-group>
                            <span v-else>
                                <span v-if="record.osscustom == 1">是</span>
                                <span v-else>否</span>
                            </span>
                        </a-form-item>
                        <a-form-item v-if="record.osscustom == 1 && record.ossflag == '1'" label="平台编码">
                            <a-input v-if="is_vue_task" v-model="record.osscode" />
                            <span v-else>{{record.osscode}}</span>
                        </a-form-item>
                    </a-row>
                </a-form-model>

            </a-card>
        </div>

        <a-button v-if="is_vue_task" type="primary" @click="handleOk" :loading="confirmLoading" style="display:block;margin:24px auto;">
            保存
        </a-button>
    </div>

</template>
<script>
const m_title = {
    add_platformtype: '新增平台',
    detail_platformtype: '查看平台',
    edit_platformtype: '编辑平台',
}

export default {
    components: {},
    data() {
        return {
            c_title: '',
            is_vue_task: true,
            is_new: false,
            labelCol: { span: 4 },
            wrapperCol: { span: 14 },
            rules: {
                platformtype: [
                    {
                        required: true,
                        message: '请输入平台类型编码',
                        trigger: 'blur',
                    },
                ],
                platformtypename: [
                    {
                        required: true,
                        message: '请输入平台类型名称',
                        trigger: 'blur',
                    },
                    {
                        min: 1,
                        max: 50,
                        message: '请输入1~50个字符',
                        trigger: 'blur',
                    },
                ],
            },
            confirmLoading: false,
            formItemLayout: 'horizontal',
            record: {
                id: '',
                platformtype: '', //--
                platformtypename: '', //--
                ossflag: '0',
                osscustom: '0',
                osscode: '',
                fmsflag: '0',
                fmscustom: '0',
                fmscode: '',
                umsflag: '0',
                umscustom: '0',
                umscode: '',
                configflag: '0',
                configcustom: '0',
                configcode: '',
                mcmsflag: '0',
                mcmscustom: '0',
                mcmscode: '',
            },
        }
    },

    methods: {
        handleOk() {
            this.$refs.ruleForm.validate((valid) => {
                if (valid) {
                    this.submitData()
                } else {
                    console.log('error submit!!')
                    return false
                }
            })
        },

        submitData() {
            this.confirmLoading = true
            const { params } = this.$route
            if (params.action == 'edit_platformtype') {
                this.$store
                    .dispatch({
                        type: 'platformlist/platformEdit',
                        params: this.record,
                    })
                    .then((response) => {
                        if (response.data.success == '1') {
                            this.handleCancel()
                        }
                        this.confirmLoading = false
                    })
            } else if (params.action == 'add_platformtype') {
                this.record.id = ''
                //新增
                this.$store
                    .dispatch({
                        type: 'platformlist/platformAdd',
                        params: this.record,
                    })
                    .then((response) => {
                        if (response.data.success == '1') {
                            this.handleCancel()
                        }
                        this.confirmLoading = false
                    })
            }
        },

        handleCancel() {
            this.resetForm()
            this.$router.back(-1)
        },
        resetForm() {
            this.$refs.ruleForm.resetFields()
            this.record.platformtype = 'PLATFROM-000'
        },

        getDetail(id) {
            let that = this
            that.$store
                .dispatch({
                    type: 'platformlist/platformDetail',
                    params: {
                        id: id,
                    },
                    showMsg: false,
                })
                .then((res) => {
                    if (res.status == 200 && res.data.success == '1') {
                        let result = res.data.data
                        that.record = {
                            ...result,
                        }
                    }
                })
        },
    },

    mounted() {
        const { query, params } = this.$route
        this.c_title = m_title[params.action]
        this.is_new = params.action == 'add_platformtype'
        if (!this.is_new) {
            this.getDetail(query.id)
        } else {
            this.resetForm()
        }
        this.is_vue_task = params.action != 'detail_platformtype'
    },
}
</script>

<style scoped>
/* .ant-form-inline .ant-form-item {
    margin-right: 40px;
} */

/* .bolck_box {
    padding: 20px;
}
 */
.form_title {
    background-color: #eff3f6;
    padding: 10px;
    margin-top: 10px;
}
</style>
